var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 73,
    rx: 8,
    fill: "url(#paint0_linear_580_265)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_580_265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 24.1074V17.2227C60 14.9449 58.1469 13.0918 55.8691 13.0918H17.1309C14.8531 13.0918 13 14.9449 13 17.2227V24.1074H60ZM44.7617 18.5996H53.0234C53.7839 18.5996 54.4004 19.2161 54.4004 19.9766C54.4004 20.737 53.7839 21.3535 53.0234 21.3535H44.7617C44.0013 21.3535 43.3848 20.737 43.3848 19.9766C43.3848 19.2161 44.0013 18.5996 44.7617 18.5996ZM30.9922 18.5996C31.7526 18.5996 32.3691 19.2161 32.3691 19.9766C32.3691 20.737 31.7526 21.3535 30.9922 21.3535C30.2317 21.3535 29.6152 20.737 29.6152 19.9766C29.6152 19.2161 30.2317 18.5996 30.9922 18.5996ZM25.4844 18.5996C26.2448 18.5996 26.8613 19.2161 26.8613 19.9766C26.8613 20.737 26.2448 21.3535 25.4844 21.3535C24.7239 21.3535 24.1074 20.737 24.1074 19.9766C24.1074 19.2161 24.7239 18.5996 25.4844 18.5996ZM19.9766 18.5996C20.737 18.5996 21.3535 19.2161 21.3535 19.9766C21.3535 20.737 20.737 21.3535 19.9766 21.3535C19.2161 21.3535 18.5996 20.737 18.5996 19.9766C18.5996 19.2161 19.2161 18.5996 19.9766 18.5996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 26.8613V55.7773C13 58.0551 14.8531 59.9082 17.1309 59.9082H55.8691C58.1469 59.9082 60 58.0551 60 55.7773V26.8613H13ZM29.0984 46.4404C29.6923 46.9155 29.7885 47.7819 29.3135 48.3758C28.8385 48.9695 27.9719 49.0659 27.3781 48.5908L20.4934 43.0829C19.805 42.5324 19.8045 41.4835 20.4934 40.9325L27.3781 35.4247C27.9717 34.9496 28.8384 35.0458 29.3135 35.6397C29.7885 36.2335 29.6923 37.1001 29.0984 37.575L23.5577 42.0078L29.0984 46.4404ZM41.8965 32.9116L33.6347 52.1889C33.3352 52.8878 32.5259 53.2118 31.8267 52.9121C31.1278 52.6126 30.8039 51.803 31.1035 51.1041L39.3653 31.8267C39.6649 31.1278 40.4743 30.804 41.1733 31.1035C41.8722 31.4031 42.1961 32.2125 41.8965 32.9116ZM52.5066 43.083L45.6219 48.5908C45.029 49.0652 44.1623 48.9705 43.6865 48.3759C43.2115 47.782 43.3077 46.9155 43.9016 46.4405L49.4423 42.0078L43.9016 37.5752C43.3077 37.1002 43.2115 36.2337 43.6865 35.6399C44.1615 35.046 45.028 34.9497 45.6219 35.4249L52.5066 40.9327C53.195 41.4832 53.1955 42.5321 52.5066 43.083Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_580_265",
    x1: 2.5,
    y1: 3,
    x2: 69.5,
    y2: 71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#981A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124B6A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_580_265"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame3);
export default __webpack_public_path__ + "static/media/Frame3.6138ee745da76521b6e17b8fd7670d15.svg";
export { ForwardRef as ReactComponent };